import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

interface IProps {
  errorMessage?: string
}

export const FormError: FunctionComponent<IProps> = ({ errorMessage }) => {
  const { t } = useTranslation()
  return <p>{errorMessage || t('Something went wrong, please try again.')}</p>
}
